import PropTypes from 'prop-types';

import classNames from 'classnames';

// Styles
import './StudentOpinion.scss';

const StudentOpinion = ({ title = '', content = '', className = '' }) => {
  const classValue = classNames('student-opinion__title', className);

  return (
    <div className="student-opinion">
      <h3 className={classValue}>{title}</h3>
      <p className="student-opinion__content">{content}</p>
    </div>
  );
};

StudentOpinion.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string
};

export default StudentOpinion;
